module.exports = __webpack_public_path__ + "static/img/cloud11.4d369b94.png";